import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {translate} from 'views/module';

const JobTitle = (props) => {
  const {location, requirements, jobDataParsed} = props;
  const locationTitle = translate('jobDetail.JobLocation',
      {
        neighborhood: location.neighborhood,
        city: location.city,
      },
  );
  // Order the certifications according to cgTypesHierarchy
  const certifications = React.useMemo(() => {
    const cgTypesHierarchy = [
      'RN',
      'NURSING_STUDENT',
      'DSW',
      'PSW',
      'PAB',
      'CNA',
      'RPN',
      'RNA',
      'HCA',
      'PSW_STUDENT',
      'CSW',
      'SSW',
    ];
    // display Caregiving Companion as a fallback
    if (!requirements.certifications?.length &&
      !requirements?.niceToHaveCertifications?.length &&
      !requirements?.atLeastOneCertifications?.length
    ) {
      return [translate(`jobDetail.Requirements.CertificationsOptionsTitle.UNACCREDITED`)];
    }

    // throw in the niceToHaveCertifications and atLeastOneCertifications as well if there is any
    const combined = [
      ...(requirements.certifications ?? []),
      ...(requirements?.niceToHaveCertifications ?? []),
      ...(requirements?.atLeastOneCertifications ?? []),
    ];
    // get rid of duplicates
    const unique = [...new Set(combined)];
    // Sort according to cgTypesHierarchy
    const correctOrder = unique.sort((a, b) => cgTypesHierarchy.indexOf(a) - cgTypesHierarchy.indexOf(b));
    // Account for missing certifications/translations
    const filteredCertifications = correctOrder.map(
        (cert) => translate(`jobDetail.Requirements.CertificationsOptionsTitle.${cert}`),
    ).filter(
        (translation) =>
          translation && translation !== 'Missing translation',
    );

    // if we still do not match one of the cgTypesHierarchy, just display Caregiving Companion
    if (!filteredCertifications.length) {
      return [translate(`jobDetail.Requirements.CertificationsOptionsTitle.UNACCREDITED`)];
    }

    return filteredCertifications;
  }, [requirements.certifications, requirements?.niceToHaveCertifications, requirements?.atLeastOneCertifications]);

  // Put it all together to display
  const title = [certifications.join(' / '), locationTitle, jobDataParsed.payPerWeekString]
      .filter(Boolean)
      .join(' - ');

  return (
    <Typography variant="h5" sx={{fontWeight: 800, letterSpacing: -0.2}}>
      {title}
    </Typography>
  );
};

JobTitle.propTypes = {
  location: PropTypes.object.isRequired,
  requirements: PropTypes.object.isRequired,
  jobDataParsed: PropTypes.object.isRequired,
};

export default JobTitle;
